/*!
 * Copyright (c) HoaDev and contributors. All rights reserved.
 * More licensed under license file.
 * Created by HoaDev, 10/06/2022
 */

import { CAP_BAC_NHAN_VIEN_PREFIX_URL } from "../modules/cap-bac-nhan-vien/constants/config.cap-bac-nhan-vien";
import { DE_NGHI_HOAN_UNG_PREFIX_URL } from "../modules/de-nghi-hoan-ung/constants/config.de-nghi-hoan-ung";
import { DE_NGHI_MUA_SAM_PREFIX_URL } from "../modules/de-nghi-mua-sam/constants/config.de-nghi-mua-sam";
import { DE_NGHI_THANH_TOAN_PREFIX_URL } from "../modules/de-nghi-thanh-toan/constants/config.de-nghi-thanh-toan";
import { DON_VI_PREFIX_URL } from "../modules/don-vi/constants/config.don-vi";
import { LOAI_PHIEU_THANH_TOAN_PREFIX_URL } from "../modules/loai-phieu-thanh-toan/constants/config.loai-phieu-thanh-toan";
import { NHA_CUNG_CAP_PREFIX_URL } from "../modules/nha-cung-cap/constants/config.nha-cung-cap";
import { TAM_UNG_NOI_BO_PREFIX_URL } from "../modules/tam-ung-noi-bo/constants/config.tam-ung-noi-bo";
import { TIEN_TE_PREFIX_URL } from "../modules/tien-te/constants/config.tien-te";
import { QUAN_LY_PHE_DUYET_PREFIX_URL } from "./config.quan-ly-phe-duyet";

interface MenuItemInterface {
  key: string;
  label: string;
  onClick?: () => void;
}

// Tạo list menu con demo
export const LIST_MENU_TAM_UNG_NOI_BO: MenuItemInterface[] = [
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + TAM_UNG_NOI_BO_PREFIX_URL + "/create",
    label: "Tạo phiếu mới",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL + TAM_UNG_NOI_BO_PREFIX_URL + "/my-approval",
    label: "Phiếu của tôi",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      TAM_UNG_NOI_BO_PREFIX_URL +
      "/waiting-approval",
    label: "Phiếu chờ duyệt",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      TAM_UNG_NOI_BO_PREFIX_URL +
      "/my-act-approval",
    label: "Tôi đã duyệt",
  },
];

export const LIST_MENU_OTHERS: MenuItemInterface[] = [
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DON_VI_PREFIX_URL,
    label: "Đơn vị",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + TIEN_TE_PREFIX_URL,
    label: "Tiền tệ",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + CAP_BAC_NHAN_VIEN_PREFIX_URL,
    label: "Cấp bậc nhân viên",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + LOAI_PHIEU_THANH_TOAN_PREFIX_URL,
    label: "Loại phiếu thanh toán",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + NHA_CUNG_CAP_PREFIX_URL,
    label: "Nhà cung cấp",
  },
];

export const LIST_MENU_DE_NGHI_MUA_SAM: MenuItemInterface[] = [
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_MUA_SAM_PREFIX_URL + "/create",
    label: "Tạo phiếu mới",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_MUA_SAM_PREFIX_URL +
      "/my-approval",
    label: "Phiếu của tôi",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_MUA_SAM_PREFIX_URL +
      "/waiting-approval",
    label: "Phiếu chờ duyệt",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_MUA_SAM_PREFIX_URL +
      "/my-act-approval",
    label: "Tôi đã duyệt",
  },
];

export const LIST_MENU_DE_NGHI_HOAN_UNG: MenuItemInterface[] = [
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_HOAN_UNG_PREFIX_URL + "/create",
    label: "Tạo phiếu mới",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_HOAN_UNG_PREFIX_URL +
      "/my-approval",
    label: "Phiếu của tôi",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_HOAN_UNG_PREFIX_URL +
      "/waiting-approval",
    label: "Phiếu chờ duyệt",
  },
  {
    key:
      QUAN_LY_PHE_DUYET_PREFIX_URL +
      DE_NGHI_HOAN_UNG_PREFIX_URL +
      "/my-act-approval",
    label: "Tôi đã duyệt",
  },
];

export const LIST_MENU_DE_NGHI_THANH_TOAN: MenuItemInterface[] = [
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_THANH_TOAN_PREFIX_URL + "/create",
    label: "Tạo phiếu mới",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_THANH_TOAN_PREFIX_URL + "/my-approval",
    label: "Phiếu của tôi",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_THANH_TOAN_PREFIX_URL + "/waiting-approval",
    label: "Phiếu chờ duyệt",
  },
  {
    key: QUAN_LY_PHE_DUYET_PREFIX_URL + DE_NGHI_THANH_TOAN_PREFIX_URL + "/my-act-approval",
    label: "Tôi đã duyệt",
  },
];
